import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, MetaLayerDefinition } from '@agissc/ktag-map';
import SearchResultItem from './SearchResultItem';
import FavoriteButton from '../button/FavoriteButton';
import { markedLabel } from '../../utils/StringHelper';
import { MapTypeCategory } from '../../tools/mapContent/api/Contracts';

interface SearchLayerProps {
  layer: MetaLayerDefinition;
  markedText: string;
  isSelected: boolean;
  isFavorite: boolean;
  onClick: () => void;
  onToggleFavorite: () => void;
  onIconClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const SearchLayer = ({
  layer,
  markedText,
  isSelected,
  isFavorite,
  onClick,
  onToggleFavorite,
  onIconClick,
  onMouseEnter,
  onMouseLeave,
}: SearchLayerProps) => {
  const { t } = useTranslation('agisviewer');
  const resultType = MapTypeCategory.get(layer.source) ?? '';

  return (
    <SearchResultItem
      key={layer.id}
      label={markedLabel(layer.title, markedText)}
      title={layer.description}
      resultType={t(resultType)}
      isSelected={isSelected}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      isPublic={layer.isPublic}
    >
      <IconButton
        icon={isSelected ? 'minus-circle' : 'plus-circle'}
        title={isSelected ? t('remove_topic_layer') : t('add_topic')}
        onClick={onIconClick ?? onClick}
      />
      <FavoriteButton
        isFavorite={isFavorite}
        title={isFavorite ? t('favorite_remove') : t('favorite_add')}
        onClick={onToggleFavorite}
      />
    </SearchResultItem>
  );
};

export default SearchLayer;
